module.exports = __webpack_public_path__ + "static/img/service.23ccaed3.svg";